<link href="https://fonts.googleapis.com/css2?family=Caveat:wght@600&display=swap" rel="stylesheet">
<div id="resultsPage" class="container" style="padding:0px;">
  <div class="results-sections" style="padding-top:50px">
    <div class="row" style="margin:0;">
      <div class="col-md-12">
        <h1 class="main-heading">Villa Collection</h1>
      </div>

      <section class="sidebar__desc">
        <p>Crete may be one of the world's most heritage-packed islands, but when it comes to finding
          a place to stay, our luxury villas are far from ancient.
        </p>
        <p class="sidebar__quote">
          Sleek, ultramodern architectural marvels meet elegant coastal villas and charming country getaways with
          an element of rustic chic.
        </p>
        <p>
          As you sit back on your poolside terrace overlooking the coast, or perhaps even the old harbour,
          Crete will not fail to steal your heart.
        </p>
        <div class="sidebar__btn">
          <button (click)="goToSearch()" class="sidebar__btn--cta">Create your Request</button>
        </div>
      </section>

      <main class="collection">
        <div *ngFor="let hotelPreview of hotelPreviews" class="hotel-preview-card">
          <app-villa-preview [hotelPreviewInfo]="hotelPreview"></app-villa-preview>
        </div>
      </main>
      <div class="load">
        <button *ngIf="!loadingResults" class="load-more-villas" (click)="loadMore()">LOAD MORE VILLAS</button>
        <div *ngIf="loadingResults" class="loading-results"></div>
      </div>
    </div>
  </div>
</div>